module.exports = __webpack_public_path__ + "static/img/reporticon5.54bbff42.png";